App.SmTimePickerComponent = Em.Component.extend
  classNames: [ 'sm-time-picker' ]
  classNameBindings: [ 'disabled' ]

  value:            null
  timezone:         null
  timeFormat:       'HH:mm'
  momentTimeFormat: ''
  timeStep:         5
  minDate:          null
  maxDate:          null

  minTime: Ember.computed 'minDate', 'timeFormat', ->
    minDate = @get('minDate')
    timeFormat = @get('timeFormat')

    if minDate
      if @get('timezone')
        moment.tz(minDate, @get('timezone')).format( @get('timeFormat') )
      else
        moment(minDate).format( @get('timeFormat') )
    else
      null

  maxTime: Ember.computed 'maxDate', 'timeFormat', ->
    maxDate = @get('maxDate')
    timeFormat = @get('timeFormat')

    if maxDate
      if @get('timezone')
        moment.tz(maxDate, @get('timezone')).format( @get('timeFormat') )
      else
        moment(maxDate).format( @get('timeFormat') )
    else
      null

  formatTime: (value) ->
    if value
      moment(value).format( @get('timeFormat') )
    else
      ''

  # Время поменялось снаружи
  onValueChanged: (->
    if @get('value') == null
      value = ''
    else
      if @get('timezone')
        value = moment.tz(@get('value'), @get('timezone'))
      else
        value = moment(@get('value'))
    @$('.time-input').val( @formatTime(value) )
  ).observes('value')

  optionsChanged: Ember.observer(
    'timeFormat',
    'timeStep',
    'minTime',
    'maxTime',
    'timezone',
    ->
      options =
        timeFormat: @formatTime.bind(@)
        step:       @get('timeStep')

      # if @get('minTime')
      #   options.minTime = @get('minTime')

      # if @get('maxTime')
      #   options.maxTime = @get('maxTime')

      @$('.time-input').timepicker( 'option',  options )
  )

  timeChanged: ->
    value = @get('value')
    newTime  = @$('.time-input').val()
    timezone  = @get('timezone')
    if timezone
      datestr = moment.tz((if value then value else new Date), @get('timezone')).format('YYYY-MM-DD')
      newValue = moment.tz("#{datestr} #{newTime}", timezone).toDate()
    else
      datestr = moment(if value then value else new Date).format('YYYY-MM-DD')
      newValue = moment("#{datestr} #{newTime}").toDate()

    @set('value', newValue)
    @sendAction('onChange', newValue)


  attachTimePicker: (->
    $elem = @$('.time-input')

    options =
      timeFormat: @formatTime.bind(@)
      step:       @get('timeStep')

    # if @get('minTime')
    #   options.minTime = @get('minTime')

    # if @get('maxTime')
    #   options.maxTime = @get('maxTime')

    $elem.timepicker options

    if @get 'timezone'
      $elem.timepicker 'setTime', @formatTime(moment(@get 'value').tz(@get 'timezone'))
    else
      $elem.timepicker 'setTime', @formatTime(moment(@get 'value'))
    $elem.on('changeTime', @timeChanged.bind(@))
  ).on('didInsertElement')

  removeTimePicker: (->
    $elem = @$('.time-input')

    $.removeData($elem.get(0))
    $elem.off('timepicker')
    $elem.off('changeTime')
    $elem.unbind('.timepicker')
  ).on('willDestroyElement')

